import React, {
  PureComponent,
  Suspense,
  useEffect,
  useMemo,
  useState,
} from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import "./scss/style.scss";

import { connect, useDispatch } from "react-redux";
import firebase from "firebase";
import * as API from "./api/api";
import { fetchAuth, setFiresotreUser } from "./actions";
import { useWindowWidth } from "@react-hook/window-size";
import {
  atom,
  useRecoilState,
  useResetRecoilState,
  useSetRecoilState,
} from "recoil";
import { loadStripe } from "@stripe/stripe-js";
import { Elements, useStripe } from "@stripe/react-stripe-js";
import { STRIPE_PUBLISHABLE_KEY } from "./constants";
import { ThemeProvider, createTheme } from "@mui/material/styles";

import { purple } from "@mui/material/colors";
import { useCheckAuth, useIsAuth, userState } from "./atoms/user";
import { useSetBrand } from "atoms/brand";

const config = {
  apiKey: "AIzaSyBmfm1hl7-_xgBxwg7wMWixq0V2iCOhWy0",
  authDomain: "fashion-app-7b64c.firebaseapp.com",
  projectId: "fashion-app-7b64c",
  storageBucket: "fashion-app-7b64c.appspot.com",
  messagingSenderId: "625527138827",
  appId: "1:625527138827:web:e3122a2bd27bd6b73c750e",
  measurementId: "G-Q33Z7CFX51",
};
export const app = firebase.initializeApp(config);

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// Containers
const TheLayout = React.lazy(() => import("./containers/TheLayout"));

// Pages
const Login = React.lazy(() => import("./views/pages/login/Login"));
const SignUp = React.lazy(() => import("./views/pages/signUp/SignUp"));
const VerifyEmail = React.lazy(() =>
  import("./views/pages/verifyEmail/VerifyEmail")
);
const BrandManagerLogin = React.lazy(() =>
  import("./views/pages/brandManagerLogin/BrandManagerLogin")
);
const PaymentInformation = React.lazy(() =>
  import("./views/pages/PaymentInformation/PaymentInformation")
);
const CompletePayment = React.lazy(() =>
  import("./views/pages/completePayment/CompletePayment")
);
const Register = React.lazy(() => import("./views/pages/register/Register"));
const Term = React.lazy(() => import("./views/pages/term/Term"));
const Page404 = React.lazy(() => import("./views/pages/page404/Page404"));
const Page500 = React.lazy(() => import("./views/pages/page500/Page500"));
// const theme = createTheme({
//   palette: {
//     primary: {
//       main: "#B7A474",
//     },
//   },
// });

const theme = createTheme({
  palette: {
    primary: {
      main: "#B7A474",
    },
    secondary: {
      main: "#f44336",
    },
  },
});

const App = (props) => {
  const dispatch = useDispatch();

  const { firestoreUser } = props.userReducer;
  const [recoilUser, setRecoilUser] = useRecoilState(userState);
  const resetRecoilUser = useResetRecoilState(userState);
  const isAuth = useIsAuth();

  console.log("isAuth", isAuth);

  useEffect(() => {
    (async () => {
      const firestoreUser =
        recoilUser?.uid && (await API.get_user(recoilUser.uid));
      if (firestoreUser) {
        dispatch(setFiresotreUser(firestoreUser));
        setRecoilUser((state) => ({ ...state, firestoreUser }));
      }
    })();
  }, [recoilUser.uid]);

  useSetBrand();

  const checkAuth = useCheckAuth();

  useEffect(() => {
    checkAuth();
  }, [recoilUser]);

  useEffect(() => {
    firebase.auth().onAuthStateChanged(async function (user) {
      if (user) {
        // setRecoilUser((state) => ({ ...state, uid: user.uid, authUser: user }));
        setRecoilUser((state) => ({
          ...state,
          uid: user.uid,
          authUser: { email: user.email, uid: user.uid },
        }));
      } else {
        resetRecoilUser();
      }
    });
  }, []);
  const windowWidth = useWindowWidth();
  const setIsMobile = useSetRecoilState(isMobileState);
  useEffect(() => {
    setIsMobile(windowWidth < 992);
  }, [windowWidth]);

  const setCurrentSubscription = useSetRecoilState(currentSubscriptionState);
  useEffect(() => {
    (async () => {
      if (firestoreUser?.uid) {
        try {
          const result = await app
            .functions("asia-northeast1")
            .httpsCallable("getCustomerSubscriptionProduct")({
            userId: firestoreUser.uid,
          });
          setCurrentSubscription(result?.data?.product_type);
        } catch (error) {
          console.log(error);
        }
      }
    })();
  }, [firestoreUser?.uid]);

  const [stripePromise, setStripePromise] = useState(null);

  useEffect(() => {
    const stripe = loadStripe(STRIPE_PUBLISHABLE_KEY);
    setStripePromise(stripe);
  }, []);

  return (
    <Router>
      <ThemeProvider theme={theme}>
        <Suspense fallback={loading}>
          <Elements stripe={stripePromise}>
            <Switch>
              <Route
                exact
                path="/privacy"
                name="Privacy Policy"
                render={(props) => <Term {...props} />}
              />
              <Route
                exact
                path="/action"
                name="Privacy Policy"
                render={(props) => <Term {...props} />}
              />
              <Route
                path="/signUp"
                name="SignUp Page"
                render={(props) => <SignUp {...props} />}
              />
              <Route
                path="/verifyEmail"
                name="verify email Page"
                render={(props) => <VerifyEmail {...props} />}
              />
              <Route
                path="/BrandManagerLogin"
                name="brand manager login Page"
                render={(props) => <BrandManagerLogin {...props} />}
              />
              <Route
                path="/PaymentInformation"
                name="Payment Information Page"
                render={(props) => <PaymentInformation {...props} />}
              />
              <Route
                path="/CompletePayment"
                name="complete payment Page"
                render={(props) => <CompletePayment {...props} />}
              />
              {isAuth ? (
                <>
                  <Route
                    exact
                    path="/register"
                    name="Register Page"
                    render={(props) => <Register {...props} />}
                  />
                  <Route
                    path="/"
                    name="Home"
                    render={(props) => <TheLayout {...props} />}
                  />
                </>
              ) : (
                <>
                  <Route
                    path="/"
                    name="Login Page"
                    render={(props) => <Login {...props} />}
                  />
                </>
              )}
              <Route
                exact
                path="/404"
                name="Page 404"
                render={(props) => <Page404 {...props} />}
              />
              <Route
                exact
                path="/500"
                name="Page 500"
                render={(props) => <Page500 {...props} />}
              />
            </Switch>
          </Elements>
        </Suspense>
      </ThemeProvider>
    </Router>
  );
};

function mapStateToProps(state) {
  return {
    userReducer: state.userReducer,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    fetchAuth: (flag, authType) => dispatch(fetchAuth(flag, authType)),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(App);

export const isMobileState = atom({
  key: "isMobileState",
  default: false,
});

export const currentSubscriptionState = atom({
  key: "currentSubscriptionState",
  default: undefined,
});
